<template>
    <v-layout wrap fluid px-4 sm12 d-flex>
        <v-widget class="inset d-flex" :title="title">
            <v-btn slot="button-top-right" fab color="accent" @click="$emit('close')"><i class="fas fa-undo" ></i></v-btn>
            <div slot="v-widget-content">

                placeholder...
            </div>
        </v-widget>
        
    </v-layout>
    
</template>
<script>
import VWidget from '../global/VWidget'

export default {
    props:{
        title:{
            default: 'Overzicht per geo zone'
        },
        closeLabel:{
            default: 'Terug'
        },
        geoZoneTypes:{
            type:Array
        }
    },
    components: {
        VWidget
    },
    data(){
        return {

        }
    },
    computed:{

    },
    methods:{
        loadGeoZonesByType(zones){
            
        }
    },
    mounted(){
        this.loadGeoZonesByType(this.geoZoneTypes)
    }
}
</script>
<style>

</style>